module.exports = __webpack_public_path__ + "img/specialties.ae74cb46.svg";